import type us from './enUS.js'
import usUS from './enUS.js'

const currentYear = new Date().getUTCFullYear()

const esES: typeof us = {
  ...usUS,

  Header: {
    timestampFormat: (date: string) => `Última actualización: ${date}`,
    standaloneTimestampFormat: (date: string) => `de ${date}`,
    counterFormat: (count: number) => `Los ${count} mejores`,
    productsInListFormat: (count: number) => `Nuestro top ${count}`,
    titleFormat: (count: number, category: string) => `Los ${count} mejores ${category} ${currentYear} de España`,
    titleDealsFormat: (count: number, category: string) => `Las ${count} mejores ofertas de ${category} ahora mismo`,
    titleMagaTop: (count: number, category: string) => `Top-${count} ${category}`,
    top: 'Top',
    titleMagaLoved: 'Loved in the Spain',
    subtitleMaga: 'Seleccionado por su calidad y confiado por miles de clientes',
    topRated: 'Lo más valorado',
    best: (count: number, gender?: 'feminine' | 'masculine' | null) =>
      `${count} ${gender === 'feminine' ? 'Las Mejores' : 'Los Mejores'}`,
    countryPostfix: '',
    categoryTitleDateFormat: (timestamp: string) => `de ${timestamp}`,
    subtitle:
      'Investigamos por usted y recopilamos reseñas y valoraciones de expertos de toda la Web para que pueda comprar en línea con seguridad (y dedicar el tiempo ahorrado a las cosas que de verdad importan).',
    about: 'Vea cómo calculamos esta clasificación',
    marketing: 'Este año, hemos ayudado a 100 millones de consumidores.',
    aboveTheListSubheader: 'De las principales marcas y los mejores vendedores disponibles en la web',
    aboveTheListSubheaderShort: 'De las principales marcas y los mejores vendedores',
    disclaimer:
      'Al hacer clic en un enlace al sitio web de un tercero, los datos de registro se comparten con ese tercero',

    shareMenuCopyText: 'Copiar link',
    updatedText: 'Actualizado el',
    quickNavigation: [
      {id: 'topPicks', label: '3 mejores elecciones', value: 'topPicks'},
      {id: 'topRatedList', label: 'Lista de los 10 mejor valorados', value: 'topRatedList'},
    ],
    sorting: {
      title: 'Ordenar por',
      options: [
        {id: 'editorsChoice', label: 'Elección del editor', value: 'editorsChoice'},
        {id: 'discount', label: 'Descuento', value: 'discount'},
        {id: 'priceAsc', label: 'Precio (de menor a mayor)', value: 'priceAsc'},
      ],
    },
  },
  affiliateDisclosure: {
    title: 'Divulgación de afiliados',
    content:
      'Nuestra tecnología explora el mundo de las compras en línea, analizando cientos de sitios y miles de opiniones de clientes en tiempo real. Utilizando algoritmos avanzados, evaluamos productos, marcas, niveles de servicio de los comerciantes y tendencias de popularidad para generar clasificaciones inteligentes. Cuando compras productos a través de nuestro sitio, podemos ganar una comisión de afiliado por los productos destacados. Como Asociados de Amazon, ganamos con las compras que califican. Esta compensación puede influir en la ubicación y el orden en que aparecen estos productos.',
  },
  affiliationNotice: (camelCaseUrl: string) =>
    `${camelCaseUrl} se mantiene directamente a través de sus usuarios. Al comprar productos a través de nuestro sitio, podemos ganar una comisión de afiliación por los productos destacados.`,
  ReasoningSection: {
    title: '¿Cómo clasificamos los productos para ti?',
    infoText:
      'Nuestra tecnología explora a fondo el mundo de las compras en línea, revisando cientos de sitios. Luego procesamos y analizamos esta información, actualizándola en tiempo real para ofrecerte los productos mejor valorados más recientes. De esta manera, siempre obtienes las mejores y más actuales opciones disponibles.',
  },
  Attributes: {
    title: (variation?: string) => {
      switch (variation) {
        case 'v1':
          return 'What to look for?'
        case 'v2':
          return 'What attributes matter to you?'
        default:
          return 'What to look for?'
      }
    },
    subtitle: (variation?: string) => {
      switch (variation) {
        case 'v1':
          return 'Based on top-rated features'
        case 'v2':
          return 'Based on customer reviews'
        default:
          return 'Based on top-rated features'
      }
    },
  },
  BackToTop: 'Volver arriba',
  CategorySearchCombo: {
    placeholder: 'Busca lo mejor...',
    placeholderNewDesign: '¿Qué estás buscando comprar?',
    placeholderAboveTheListRedesign: 'Buscar productos...',
    NoResults: {
      title: 'No se han encontrado resultados...',
      subtitle: 'Asegúrate de que tus palabras estén escritas correctamente.',
    },
    Error: {
      title: 'Ocurrió un error',
      subtitle: 'Por favor, inténtelo de nuevo más tarde',
    },
    cancel: 'Cancelar',
    topCategories: 'Categorías principales',
    mostRelevant: 'Lo más relevante:',
  },
  ShareDisclaimer:
    'Al hacer clic en cualquier enlace o continuar, acepta la compartición de información técnica con terceros para análisis, mejoras de servicio y propósitos comerciales relacionados.',
  AppBar: {
    description: 'Ayudando a miles cada mes',
    about: 'Acerca de',
    categories: 'Categorías',
    limitedTimeDeals: 'Limited-time deals 🎉',
    primeBig: 'Prime Big',
    dealDays: 'Deal Days',
    shop: 'Shop ',
  },
  TopPicks: {
    title: 'Nuestras mejores selecciones',
    compareTitle: 'Comparar las mejores selecciones',
    viewOnAmazon: 'Ver en Amazon',
    deal: 'Oferta',
    chosenBy: 'Elegido por',
    multipleStylesAvailable: 'Estilos múltiples disponibles',
    brief: {
      readMore: (isOpen: boolean) => (isOpen ? 'Mostrar menos' : 'Mostrar más'),
    },
    specifications: {
      title: 'Especificaciones',
    },
    keyFeatures: {
      title: 'Características clave',
    },
  },
  Footer: {
    customerService: 'Servicio al cliente',
    Navigation: [
      {
        title: 'Compañía',
        id: 'company',
        menuItems: [
          {
            title: 'Acerca de',
            id: 'about',
            href: '/about',
          },
          {
            title: 'Contacto',
            id: 'contact',
            href: '/contact',
          },
          {
            title: 'FAQ',
            id: 'faq',
            href: '/faq',
          },
          {
            title: 'Privacidad',
            id: 'privacy',
            href: '/privacy-policy',
          },
          {
            title: 'Términos',
            id: 'terms',
            href: '/terms-of-service',
          },
          {
            title: 'Descargo de responsabilidad',
            id: 'disclaimer',
            href: '/disclaimer',
          },
          {
            title: 'No vender mi información personal',
            href: '/sharing-policy',
            id: 'sharing',
          },
          {
            title: 'CCPA',
            href: '/ccpa',
            id: 'ccpa',
          },
        ],
      },
      {
        title: 'Herramientas de compra',
        id: 'shipping-tools',
        menuItems: [
          {
            title: 'Para los vendedores',
            id: 'for-sellers',
            href: 'https://roundforest.com/sellers/?utm_source=BRG&utm_medium=web&utm_campaign=popup',
          },
          {
            title: 'Best Deals Today',
            id: 'best-deals-today',
            href: 'https://www.bestdeals.today',
          },
        ],
      },
      {
        title: 'Más',
        id: 'more',
        menuItems: [
          {
            title: 'Categorías',
            id: 'categories',
            href: '/',
          },
        ],
      },
    ],
  },
  ProductCard: {
    availableOn: 'Disponible en',
    view: 'Ver',
    viewProduct: 'Ver producto',
    viewOptions: (isShortened?: boolean): string => (isShortened ? 'Ver opciones' : 'Ver más opciones'),
    ctaText: (trafficType?: string, partnerName?: string) => {
      switch (trafficType) {
        case 'organic-amazon-only':
          return 'Más información'
        case 'paid-long-tail':
          return 'Más información'
        case 'organic-buying-options':
          return 'Ver el producto'
        case 'dws':
          return 'Ver oferta'
        default:
          return `Ver en ${partnerName ? partnerName.charAt(0).toUpperCase() + partnerName.slice(1) : 'Amazon.es'}`
      }
    },
    ctaTextBuy: 'Comprar en Amazon',
    onlyOn: 'Only on',
    ctaSecondaryText: 'Cómpralo en Amazon',
    ctaTextView: 'Ver en Amazon',
    ctaPartnerizeTextBuy: 'Ver en Chewy',
    scoreSuffix: 'de puntuación',
    getCode: 'OBTENER CÓDIGO',
    copyAndApplyNow: 'COPIAR Y SOLICITAR AHORA',
    additionalCtaText: 'Ver oferta',
    compare: 'Comparar',
    moreInfo: 'Más información',
    checkPrice: 'Consultar precio',
    topReview: 'Reseña de usuario más útil:',
    verifiedReviews: 'Reseñas verificadas',
    reviewsFormat: (count: string) => `${count} reseñas`,
    bargianScore: 'puntuación de ganga',
    buyersCount: (count: string) => `${count} comprados el mes pasado`,
    discountFormat: (discount: number) => `${discount}% de descuento`,
    hotDealDiscountFormat: (discount: number) => `Descuento de última hora del ${discount}%`,
    productFeaturesToggle: 'Aspectos destacados del producto',
    keyFeatures: 'Características principales',
    productSpecsTitle: 'Lo que nos gusta 🙂',
    readKeyFeaturesCtaText: (isOpen: boolean) => (isOpen ? 'Ver menos' : 'Ver más'),
    readFullReview: 'Leer reseña completa',
    viewFullReview: 'Ver reseña completa',
    viewMoreImages: 'Ver más imágenes',
    productSpecsNewTitle: 'Características clave',
    viewMore: (expanded?: boolean) => (expanded ? 'Ver menos' : 'Ver más'),
    toggleText: 'Opiniones de los compradores',
    productBuyingOptionsToggle: 'Comparar precios',
    productGenericToggle: 'Más información',
    viewSources: 'Ver fuentes',
    basedOn: 'Puntuación basada en',
    highlightTextPart1: 'El producto que ha visto es bueno, pero',
    highlightTextPart2: 'seguro que hay uno mejor',
    highlightFirstTextPart1: 'Excelente elección.',
    highlightFirstTextPart2: 'Ha elegido el producto más valorado del mercado',
    headerHighlightTextPart1: 'El producto que ha visto no ha superado nuestro proceso de selección.',
    headerHighlightTextPart2: 'Busquemos un producto de alta calidad que no se arrepienta de comprar',
    customerHighlights: {
      title: 'Aspectos destacados de los clientes',
      subtitle: 'Un resumen de opiniones reales para destacar lo que dicen los compradores.',
      reviewsTitle: 'Lo más importante de ',
      reviewsCount: (count: number) => `${count} reseñas`,
      rating: 'Calificación',
      chosenBy: 'Elegido por',
      openTopics: (isOpen: boolean) => (isOpen ? 'Menos sobre este tema' : 'Más sobre este tema'),
      openReviews: (isOpen: boolean) => (isOpen ? 'Ver menos' : 'Ver más'),
    },
    variantsIndication: {
      title: 'Disponible en:',
    },
  },
  Badge: {
    freeShipping: 'Envío gratis',
    winner: 'Ganador',
    greatChoice: 'Gran elección',
    bestValue: 'Mejor relación calidad-precio',
    sponsored: 'Patrocinado',
    bestChoice: 'Mejor elección',
    bigPriceDrop: 'Gran caída de precios',
    valueForMoney: 'Buena relación calidad-precio',
    customerFavorite: 'Favorito del cliente',
    countryFavorite: 'España Favorito',
    countryPick: 'España Recomendado',
    signaturePick: 'Selección exclusiva',
    lastPurchases: 'Last Purchases',
    trustUsBrands: 'Curated products trusted by',
    topRated: 'Top Rated',
    countryTopRated: 'Top Rated in España',
    discountAmount: (discount?: number) => `${discount}%`,
    off: 'OFF',
    discountTitle: 'Descuento del',
    discountOff: (value?: number) => `${value}% OFF`,
    exclusiveCouponTitle: 'Cupón exclusivo',
    prosAndCons: 'Pros & Cons',
    editorsChoice: 'Elección del editor',
    chosenBy: (value: number) => `Elegido por ${value} esta semana`,
    primeDiscount: (value?: number) => `${value}% Off for Prime`,
    fastDelivery: 'Entrega rápida',
    dealsMoveFast: 'Puede que mañana ya no esté. ¡Las mejores ofertas vuelan!',
    freshPriceDrop: 'Bajada de precio reciente',
    discountTextInfo: (variation?: string) => {
      switch (variation) {
        case 'preTariff':
          return 'Item still has Pre-Tariff price'
        case 'solid':
          return 'Solid Value from a Trusted Brand'
        default:
          return 'Item still has Pre-Tariff price'
      }
    },
    magaBadge: (variation?: string) => {
      switch (variation) {
        case 'born':
          return 'Nacido en USA'
        default:
          return 'Nacido en USA'
      }
    },
  },
  HustonProblemModal: {
    title: 'Houston, we have a problem...',
    subtitle_p1: 'But don’t worry!',
    subtitle_p2: 'Click here and get back to shopping like nothing ever happened',
    goToAmazonCta: 'Go To Amazon',
    backToListCta: 'Back to list',
  },
  MoreProducts: {
    title: 'Otros productos destacados',
  },
  RelatedProducts: {
    title: 'Productos relacionados',
    subTitle: (discount: number) => `Hasta un ${discount} % de descuento`,
    subTitleUITest: (discount: number) => `Hasta un ${discount} % de descuento`,
    discount: 'DE DESCUENTO',
  },
  RankSection: {
    rankedByExperts: 'Clasificado por expertos e IA',
    contentTitleAI: 'Aprobado por humanos, no solo ordenado por IA',
    contentDescriptionAI:
      'Nuestra IA clasifica productos a gran escala, pero nuestros expertos van más allá: revisan opiniones reales y el valor general antes de que un producto llegue a nuestra lista',
    contentAnalyzed: 'de productos analizados hoy',
    contentAnalyzedQty: '~2M  ',
    weAnalyze: 'Analizamos',
    chips: [
      {id: 'prices', label: 'Precios en tiempo real'},
      {id: 'reviews', label: 'Opiniones y comentarios'},
      {id: 'sales', label: 'Ofertas y descuentos'},
      {id: 'sellers', label: 'Fiabilidad del vendedor'},
      {id: 'more', label: '+10 parámetros'},
    ],
    title: '¿Cómo clasificamos?',
    contentTitle: '¡Así clasificamos los productos para ti!',
    contentDescription:
      'Nuestra tecnología explora minuciosamente el mundo de las compras en línea, revisando cientos de sitios. Luego procesamos y analizamos esta información, actualizándola en tiempo real para ofrecerte los productos mejor valorados más recientes. De esta manera, siempre obtienes las mejores y más actuales opciones disponibles.',
  },
  ShippingSection: {
    title: 'Envío desde los almacenes regionales de Amazon',
  },
  WhyAmazonSection: {
    title: '¿Por qué Amazon?',
    dealsCount: (count: number) => `~${count}K `,
    dealsMade: `ofertas realizadas hoy`,
    specs: [
      {id: 'freeDelivery', label: 'Envío gratis', description: '1–3 días a tu casa'},
      {id: 'easyReturns', label: 'Devolución sencilla', description: 'En 30 días, en línea'},
      {id: 'verifiedReviews', label: 'Reseñas verificadas', description: 'Con imágenes reales'},
    ],
  },
  ExploreShoppingSection: {
    title: 'Explora otros productos mejor valorados en esta categoría',
    viewMoreDeals: 'Ver más ofertas',
  },
  AdditionalProductsSection: {
    title: 'Más excelentes opciones para ti',
  },
  RecommendedLists: {
    title: 'Listas recomendadas',
    linkText: 'Ver lista',
    topRated: 'Lo más valorado',
  },
  BuyingGuide: {
    title: (categoryName: string) => `Guía para comprar lo mejor en ${categoryName}`,
    faq: 'PREGUNTAS FRECUENTES',
    types: 'Tipos',
    reviewers: 'Opiniones de críticos',
    features: 'Características importantes',
    brands: 'Marcas más valoradas',
  },
  CookieConsent: {
    title: 'Utilizamos cookies',
    gotItButton: 'Entendido',
    acceptButton: 'Aceptar',
    rejectButton: 'Rechazar',
    newConsentText: `Utilizamos cookies para mejorar la seguridad, el rendimiento y la funcionalidad, y con fines analíticos y promocionales. Si continúa navegando por este sitio, acepta nuestra <a href='/privacy-policy'>política de privacidad</a>`,
    consentText: `Utilizamos cookies para mejorar la seguridad, el rendimiento y la funcionalidad, y con fines analíticos y promocionales. Si continúa navegando por este sitio, acepta nuestra <a href='/privacy-policy'>política de privacidad</a>`,
  },
  CategoriesSearchPage: {
    title: 'Más opciones de las listas mejor valoradas',
    bySearchTerm: 'Por términos de búsqueda:',
    viewList: 'Ver lista',
  },
  Home: {
    Header: {
      peopleSavedTitle: 'Más de 2,5 millones+ de personas ahorraron aquí el mes pasado',
      topRatedPicks: 'Selecciones mejor valoradas',
      bestPrices: 'Mejores precios',
      expertReviewsDiscounts: 'Reseñas de expertos se unen a grandes descuentos.',
    },
    Deals: {
      title: 'Ofertas del día',
      bestIn: (placement: number, category: string) => `#${placement} en ${category} ➔`,
    },
    TopDiscounted: {
      title: 'Grandes descuentos en productos mejor valorados',
      shopBestDeals: 'Compra las mejores ofertas en',
    },
    RankBanner: {
      title: '¡Cómo clasificamos los productos para ti!',
      description:
        'Revisamos el historial de precios y valoraciones para mostrarte ahorros reales en productos mejor valorados, analizando reseñas y calificaciones para ofrecerte lo mejor y más actualizado.',
    },
    DidYouKnowBanner: {
      title: '¿Sabías que?',
      description: 'No necesitas tener 20 pestañas abiertas—ya hemos comparado las mejores ofertas por ti',
    },
    SocialProofBanner: {
      title: 'Más de 2,5 millones+ de compradores ahorraron dinero aquí el mes pasado',
    },
    ExploreLists: {
      title: 'Categorías para explorar',
    },
    DealsLists: {
      title: 'Categorías con grandes ofertas',
      onSale: (count: number) => `${count} en oferta hoy`,
    },
    RecommendedLists: {
      title: 'Listas recomendadas para ti',
    },
    BigSave: {
      title: 'Grandes ahorros en artículos de calidad',
    },
    SponsoredDeals: {
      title: 'Ofertas patrocinadas',
    },
    topRated: 'Mejor valorado',
    viewAll: 'Ver todo',
    viewDeal: 'Ver oferta',
    viewList: 'Ver lista',
    bestCategories: 'Categorías más populares',
    allCategories: 'Todas las categorías',
    homePageTitle: 'Mejor valorado y altamente curado',
    homePageSubTitle:
      'Comprar en línea no debería sentirse como trabajo. \nDéjanos encontrar los mejores productos para ti, según todos.',
    categories: 'Categorías',
    productsAnalyzed: 'Productos analizados',
    Page: {
      title: `Mejores productos de ${currentYear} : Mejores marcas, reseñas y precios`,
      ogTitle: `Mejores productos de ${currentYear} : Mejores marcas, reseñas y precios`,
      description:
        '¿Buscas los MEJORES productos para comprar? ➤ Encuentra aquí los TOP productos en miles de categorías ➤ Compara precios, popularidad y calidad. ➤ Guías de compra completas',
    },
    RelatedProducts: {
      title: 'Productos promocionados',
      subTitle: (discount) => `Hasta ${discount}% de descuento`,
      discount: 'DESCUENTO',
    },
    additionalCtaText: 'Ver oferta',
    topRatedData: [
      {title: 'Caminadoras compactas'},
      {title: 'Cubiertas de colchón'},
      {title: 'Impresoras'},
      {title: 'Barras de sonido para TV'},
      {title: 'Deshumidificadores'},
      {title: 'Aspiradoras verticales'},
    ],
  },
  ImprovedHomePage: {
    Header: {
      upTitle: 'El mejor lugar para comparar en línea',
      title: 'Explora nuestras listas de compra para comprar con inteligencia',
      subtitle: 'Selecciones cuidadas para ayudarte a comprar con confianza',
    },
    TopLists: {
      title: 'Comparación',
      ourTopLists: 'Nuestras listas principales',
      byCategories: 'Por categorías',
      topQuantityAnalyzed: (count: number, quantity: number) => `Top ${count} de ${quantity} analizados`,
    },
    Trending: {
      title: 'Reseñas de productos',
      trendingNow: 'Tendencia ahora',
      viewedQuantity: (count: string) => `${count} vistos`,
      updatedIn: (date: string) => `Actualizado ${date}`,
      readFullReview: 'Leer reseña completa',
    },
    TopRated: {
      title: 'Bajada de precio en vivo',
      topRatedDiscounts: 'Descuentos mejor valorados',
      buyItOnAmazon: 'Cómpralo en Amazon',
    },
    Metrics: {
      title: 'Nuestra metodología',
      howWeFindTheBest: '¿Cómo encontramos lo mejor para ti?',
      qualityMetrics: [
        {
          id: 'productsCoverage',
          title: 'Cobertura de productos',
          percent: 95,
          description:
            'Analizamos una amplia gama de tiendas y marketplaces en línea, cubriendo cientos de fuentes para asegurarnos de que no se pierda ningún producto relevante.',
        },
        {
          id: 'dataProcessing',
          title: 'Procesamiento de datos',
          percent: 100,
          description:
            'Estructuramos, limpiamos y normalizamos grandes cantidades de datos de productos para que las comparaciones sean precisas y útiles. Esto garantiza que cada producto se evalúe con información consistente y confiable, en lugar de datos brutos y desordenados.',
        },
        {
          id: 'reviewsAnalyzed',
          title: 'Análisis de reseñas',
          percent: 80,
          description:
            'Analizamos e interpretamos grandes volúmenes de reseñas de clientes para identificar patrones reales, no solo valoraciones superficiales. Esto permite destacar ventajas, desventajas y problemas recurrentes que realmente importan a los compradores.',
        },
        {
          id: 'upToDate',
          title: 'Actualizado',
          percent: 100,
          description:
            'Nuestro sistema actualiza continuamente los datos de productos, precios y disponibilidad para reflejar el mercado actual. Así, los usuarios siempre ven recomendaciones relevantes en lugar de ofertas desactualizadas o productos descontinuados.',
        },
      ],
      about: 'Sobre nosotros',
      description:
        'Desde 2014, hemos ayudado cada mes a más de 2,5M de compradores a decidir qué comprar. Nuestros editores trabajan de forma independiente de nuestro equipo comercial: las clasificaciones no se pueden comprar y nuestra metodología se publica por completo.',
      meetTheTeam: 'Conoce al equipo',
    },
    Articles: {
      title: 'Nuestro blog',
      latestArticles: 'Artículos más recientes',
    },
  },
  ProductFeaturesPage: {
    redirectButtonCtaText: '',
    backToList: 'Back to top rated list',
    scoreSuffix: 'score',
    backToTop: 'Back to top',
    ctaText: 'View on Amazon',
    shopNow: 'Shop Now',
    KeyFeatures: {
      title: 'Key Features',
    },
    Faq: {
      title: 'FAQ',
    },
    UserValue: {
      valueForMoney: 'Value for money',
      userExperience: 'Easy of use',
      performanceAndFeatures: 'Quality',
    },
    FactorsToConsider: {
      title: 'Factors to Consider',
    },
    BottmoLine: {
      title: 'The Bottom Line',
    },
    ProductWithDiscount: {
      title: (discount: number) => `Now for ${discount}% off`,
    },
    NotMatch: {
      title: "Didn't match",
      subtitle: 'View Other Products',
    },
    Feedback: {
      title: 'As we redirect you, let us know why',
      variations: [
        {id: 1, label: 'Want to browse more options'},
        {id: 2, label: 'Product isn’t right for me'},
        {id: 3, label: 'Not enough details'},
      ],
      backToList: 'Go back to the list',
      thankYou: 'Thanks for sharing! Returning to the list',
    },
  },
  Contact: {
    Page: {
      title: (siteName: string) => ` Contact - ${siteName}`,
      ogTitle: (siteName: string) => `${siteName} - Compare and Shop The Best Stuff ${currentYear}`,
      description: (siteName: string) =>
        `${siteName} analyzes thousands of articles and customer reviews to find the top-rated products at today’s lowest prices. Best products, best offers.`,
    },
    header: `Let's talk`,
    subheader: `We're here to help`,
    content: `Feel free to share your thoughts or ask any questions via our support email. If you're a seller, we have all the information gathered for you over on our`,
    seller: 'seller page',
  },
  AboutPageMeta: {
    title: 'Sobre nosotros | Mejores decisiones, empezando por una mejor experiencia de compra.',
    description:
      'Las compras en línea prometían comodidad. Pero, demasiadas veces, ofrecían saturación: miles de opciones, reseñas contradictorias y esa sensación constante de que probablemente habías elegido mal. Estamos aquí para cambiar eso.',
  },
  About: {
    title: 'About Us',
    mainHeadingDesktop: 'We help people make decisions with peace of mind. Starting with shopping.',
    mainHeadingMobile: 'We help people make shopping decisions with peace of mind.',
    bodyTextDesktop: (siteName: string) =>
      `${siteName}, and we're here to change the online shopping game. As the number of online options grows and reliable resources dwindle, it can be difficult to know where to start. That's where we come in. ${siteName} builds succinct, top-rated product lists to ensure that your shopping choices are effortless and consistently spot-on.`,
    bodyTextMobile: (siteName: string) =>
      `We're ${siteName} revolutionizing online shopping. As options increase and reliable sources decrease, finding the right products is challenging. We simplify this with concise, top-rated product lists to make your shopping decisions effortless and accurate.`,
    statsHeading: `We've got you covered`,
    statsSubheading: `and our millions of other monthly users`,
    stats1Value: '2M',
    stats1Title: `Products analyzed <br> daily`,
    stats2Value: '500K+',
    stats2Title: `Comparison <br> pages`,
    stats3Value: '20',
    stats3Title: `Domains, 9 locals,<br> 5 languages`,
    stats4Value: '9',
    stats4Title: `Years of helping people <br> shop smarter`,
    statsBottomText: `And always one day closer to entirely eliminating buyer’s remorse for good!`,
    contactHeading: 'Got any other questions on your (shopping) list?',
    contactText: (hostname: string) =>
      `Have something to share? We're all ears. Reach out to our dedicated team at contact@${hostname?.replace(/^www\./, '')}. But beware! We're not just listeners – we're doers too! So let's make it happen.`,
    ctaText: 'Get in touch',
  },
  AboutEnhanced: {
    title: 'Sobre nosotros',
    subTitle_betterDecisions: 'Mejores decisiones,',
    subtitle_startingWith: 'empezando por una mejor',
    subtitle_shopping: 'experiencia',
    subtitle_experience: 'de compra.',
    description_1:
      'Las compras en línea prometían comodidad. Pero lo que muchas veces ofrecían era saturación: miles de opciones, reseñas contradictorias y esa sensación constante de que probablemente habías elegido mal.',
    weAreHereToChangeIt: 'Estamos aquí para cambiar eso.',
    description_2:
      'Nuestro contenido lo crea un equipo de editores, investigadores y especialistas técnicos enfocado en ofrecer información precisa, fiable y práctica. Profesionales editoriales revisan y perfeccionan cada pieza para garantizar claridad, coherencia y altos estándares. Nuestro equipo de investigación analiza productos, compara características clave y evalúa datos y opiniones de usuarios para respaldar cada recomendación. Detrás de escena, nuestro equipo tecnológico mantiene los sistemas que hacen que nuestra plataforma sea rápida, organizada y actualizada. Cada artículo sigue un proceso estructurado de investigación, revisión editorial y actualizaciones continuas, para que la información que encuentras aquí siga siendo confiable y relevante.',
    whoWeAre: 'Quiénes somos',
    meetTheTeam: 'Conoce al equipo',
    quote: '"La mejor compra es la que nunca tienes que cuestionar."',
    stats: [
      {
        id: 'recommendations',
        title: 'RECOMENDACIONES INTELIGENTES',
        value: '25+',
        description: 'Categorías con mejores opciones',
      },
      {
        id: 'scanning',
        title: 'siempre analizando',
        value: '2M',
        description: 'Productos analizados al día',
      },
      {
        id: 'experience',
        title: 'Nuestra experiencia',
        value: '10',
        description: 'Años de compras inteligentes',
      },
      {
        id: 'service',
        title: 'Nuestro servicio',
        value: '500K+',
        description: 'Páginas de comparación',
      },
    ],
    approach: {
      title: 'Nuestro enfoque',
      dataDriven: 'Basado en datos',
      editoriallyIndependent: 'Independencia editorial',
      content: [
        {id: 'scanning', text: 'Escanea continuamente millones de productos en distintas categorías'},
        {id: 'analysis', text: 'Analiza especificaciones, precios, señales de vendedores y rendimiento real'},
        {id: 'identification', text: 'Identifica lo que realmente vale la pena comprar, sin relleno'},
        {id: 'learning', text: 'Aprende y mejora constantemente con 40M de interacciones mensuales de usuarios'},
      ],
    },
    contactUsTitle: 'Contáctanos',
    contactUsSubtitle: '¿Tienes alguna otra pregunta en tu lista (de compras)?',
    contactUsContent_1: '¿Tienes algo que compartir? Te escuchamos. Ponte en contacto con nuestro equipo dedicado en',
    contactUsContent_2: 'Pero cuidado: no solo escuchamos, también actuamos. ¡Hagámoslo realidad!',
    getInTouch: 'Ponte en contacto',
  },
  ProductList: {
    noMoreInfo: 'No hay datos disponibles',
    captionFormat: (value: string) => `De ${value} productos relevantes analizados.`,
    categoryFormat: (index: number, categoryName: string) => `N.º ${index} en ${categoryName}`,
  },
  PopularCategories: {
    title: 'Categorías más populares ahora mismo',
  },
  Disclaimer: (camelCaseUrl: string) => ({
    title: 'Disclaimer',
    p1: `${camelCaseUrl} provides information for general information purposes and does not
          recommend particular products or services.`,
    p2: `Nothing within this website (${camelCaseUrl}) is, or shall be deemed, to constitute
          financial or other advise or a recommendation to purchase any product or service.`,
    p3: `The service provided by ${camelCaseUrl} expressly disclaims to the fullest extent of the
          law all express, implied, and statutory warranties regarding the information contained on the Website.
          ${camelCaseUrl} does not represent or warrant the accuracy or reliability of the information,
          and will not be liable to any user on account of their use or misuse of information found on ${camelCaseUrl}.`,
    p4: `We strongly recommend that independent professional advice is obtained before you
          purchase any product or service via ${camelCaseUrl}.`,
  }),
  OldFaq: {
    title: 'FAQ',
    header1: 'How to Unsubscribe from Push Notifications',
    p1: 'We are sorry for the inconvenience, but unfortunately, it is not in our power to unsubscribe you. Please see below a helpful guide where you can unsubscribe directly from the browser. We hope you enjoyed our recommendations and you are more than welcome to visit us again.',
    header2: 'Desktop',
    list1_item1: 'On your computer, open Chrome.',
    list1_item2: 'On the left of the web address, click on the Lock icon.',
    list1_item3_click: 'Click on ',
    list1_item3_site: 'Site settings.',
    list1_item4: 'Change the notifications permission setting.',
    list1_item5: 'Your changes will automatically save.',
    header3: 'Android',
    list2_item1: 'On your Android phone or tablet, open the Chrome app.',
    list2_item2: 'On the right of the address bar, tap More Info.',
    list2_item3_tap: 'Tap on ',
    list2_item3_site: 'Site settings.',
    list2_item4:
      'To make a change, under “Permissions” tap a setting. If you don’t see a “Permissions” section, the site doesn’t have any specific permissions.',
    header4: 'iPhone & iPad',
    list3_item1: 'On your iPhone or iPad, open the Chrome app.',
    list3_item2: 'At the bottom right, tap More Settings.',
    list3_item3_tap: 'Tap on ',
    list3_item3_content: 'Content settings.',
    list3_item4: 'Tap the permission you want to update',
  },
  FAQ: {
    title: 'FAQ',
    question1: 'How do you select your product recommendations?',
    answer1: (
      camelCaseUrl: string,
    ) => `${camelCaseUrl}'s product recommendations are meticulously curated using cutting-edge AI technology. Our system scans millions of validated data points, including user reviews and expert analyses. This ensures that our recommendations are based on comprehensive and unbiased information, giving you the confidence to make informed decisions.
      `,

    question2: 'How do you make money?',
    answer2:
      "We may earn affiliate commissions if our recommendations were helpful and you made a purchase through our provided links. These commissions come at no extra cost to you and support us in maintaining our service. Rest assured, our commitment to accuracy remains unwavering as our fee is flat for all products and we don't accept incentives from retailers that could compromise the integrity of our recommendations.",

    question3: 'Do you use my personal data?',
    answer3: (camelCaseUrl: string) =>
      `We take your privacy seriously. ${camelCaseUrl} follows strict data protection and security measures to safeguard your personal information. We do not share your data with third parties without your explicit consent. For more details on how we handle your data, please refer to our Privacy Policy.`,

    question4: 'There are so many fake review sites. Why should I trust you?',
    answer4: (siteName: string) =>
      `In a sea of fake review sites, ${siteName} stands out for its commitment to authenticity. Our platform sources information from trusted user reviews, expert analyses, and reliable critic sites. We're dedicated to transparency, providing you with accurate and unbiased insights to make informed decisions. Our rigorous data collection process ensures that you receive reliable information, making ${siteName} a trustworthy partner on your journey to smart shopping.`,

    question5: 'What sets you apart from other shopping recommendation sites?',
    answer5: (siteName: string) =>
      `Unlike more extensive review sites, we understand that your time is valuable. That's why we prioritize the bottom line score and position on the list, enabling you to quickly identify the top products in each category. ${siteName} is designed to provide you with the clear and concise insights you need to make well-informed decisions efficiently.`,

    question6: 'Why Do You Have Sponsored Products?',
    answer6:
      'Our commitment to transparency and honesty is paramount. While we prioritize unbiased recommendations, we also collaborate with trusted sellers who offer great products and services. Occasionally, these sponsored products may appear at the top of our lists without ranking, with a visible tooltip indicating their sponsorship. This approach maintains our dedication to unbiased insights, giving you clear visibility into our recommendations.',
  },
  PrivacyPolicy: {
    title: 'Privacy Policy',
    summary: 'Summary',
    p1: `Roundforest Ltd. (“Roundforest”, “we”, “our” or the “Company”)
          respects the privacy of its partners, websites visitors, and vendors, and is committed
          to protecting the personal information you may share with us (these and any others with
          respect to whom we collect personal data, shall collectively be referred to as “user”,
          “you” or “Data Subjects”).`,
    p2: (hostanme: string) => `Roundforest helps simplify shopping experiences for online consumers through its
          websites and online platforms (including: ${hostanme}) (together, the “Services”).`,
    p3: `This policy and notice (the “Privacy Policy”) explains the types of information we
          collect from you, that we receive about you or that you may provide in the course of your interest in our
          Services, transactions with us or otherwise when you visit our websites. We are transparent about our
          practices regarding the information we collect, use, maintain and process and describe our practices in
          this policy and notice. Please read the following carefully to understand our practices regarding your
          personal data and how we will treat it.`,
    p4: `For the purposes of EU General Data Protection Regulation (the “GDPR”), the
          California Consumer Privacy Act, as amended (“CPRA”) and other applicable privacy laws,
          Roundforest is a data controller (or a business, under CPRA) in relation to the personal data of its users,
          partners, employees and website visitors.`,
    header1: '1. Which information may we collect?',
    p5: `we collect various categories of personal data in order to meet our contractual obligations,
          and also to meet various legitimate interests, such as fraud prevention and marketing.
          We collect data about you in connection with your transactions with us, or in processing data for our users.
          We also collect data about our employees and website visitors. One type of data collected is non-identifiable
          and anonymous information (“non-personal data”). We also collect several categories of personal data
          (“Personal Data”), as described below.`,
    p6: `Personal Data which is being gathered consists of any details which are personally
          identifiable and which are provided consciously and voluntarily by you, through your registration and use of
          our websites (as described below), by email, or other ways in which you communicate and interact with us.
          This generally includes your name (first and last), email address, company, role, country, and online
          identifiers such as IP address or Google Click ID. Additionally, we may obtain location data related to the
          geographic location of your laptop, mobile device or other digital device on which the our platforms are used.`,
    p7: `You do not have any legal obligation to provide any information to Roundforest,
          however, we require certain information in order to perform contracts, or to provide any Services.
          If you choose not to provide us with certain information, then we may not be able to provide you or
          your organization with some or all of the Services.`,
    p8: `By contacting us or submitting requests for information or support via the websites, email etc.,
          we will collect details, including also your name, personal or company email you provided,
          country and other information provided by you. We use this information to offer our Services and support.`,
    header2: `2. How do we collect personal data of yours?`,
    p9: `we collect Personal Data when you or your organization send it to us, or when a vendor,
          distributor or other business partner, sends it to us; we collect Personal Data through our website and
          Services, and through our interactions with you.`,
    p10: `We collect Personal Data required to provide Services when you register interest,
          or when you provide us such information, by entering it manually or automatically, in the course of
          preparing a contract, or when purchasing Roundforest in-game purchases or otherwise in engaging with us.
          We also collect Personal Data when you call us for support, in which case we collect the information you
          provide us. We also collect Personal Data through your use of our websites. In other words, when you are
          using any one of these platforms, we are aware of it and may gather, collect and record the information
          relating to such usage, either independently or through the help of third-party services as detailed below.
          This includes technical information and behavioral information such as the user’s Internet protocol (IP)
          address used to connect your device to the Internet or an identifier attributed to you by a third party,
          your uniform resource locators (URL), operating system, type of browser, browser plug-in types and versions,
          screen resolution, time zone setting, the user’s ‘clickstream’ on the platform, the period of time the user
          visited the platform, methods used to browse away from a page, and any phone number used to call our users’
          service number. We likewise may place cookies on your browsing devices (see 'Cookies' section below).`,
    header3: `3. What are the purposes of personal data we collect?`,
    p11: `we process Personal Data to meet our obligations, protect our rights, and manage our business.`,
    p12: `We will use Personal Data to provide and improve our Services to our users and
          others and meet our contractual, ethical and legal obligations. All Personal Data will remain accurate
          complete and relevant for the stated purposes for which it was processed, including for example:`,
    p13: `Processing which is necessary for the performance of a contract to which you are a party or in order to take
          steps at your request prior to entering into a contract:`,
    list1_item1: `carrying out our obligations arising from any contracts entered into between you and Roundforest and/or
            any contracts entered into with Roundforest and to provide you with the information, gaming elements,
            support and Services that you request from Roundforest;`,
    list1_item2: `verifying and carrying out financial transactions in relation to payments you make in connection with
            the Services.`,
    p14: `Processing which is necessary for the purposes of the legitimate interests pursued
          by Roundforest or by a third party of providing an efficient and wide-ranging service to users:`,
    list2_item1: `notifying you about changes to our Services and/or to financial products we manage;`,
    list2_item2: `contacting you to give you commercial and marketing information about events or promotions or additional
            products or Services offered by Roundforest which may be of interest to you,
            including in other locations;`,
    list2_item3: `soliciting feedback in connection with the Services;`,
    list2_item4: `tracking use of Roundforest Services to enable us to optimize them;`,
    list2_item5: `for security purposes.`,
    p15: `Processing which is necessary for compliance with a legal obligation to which Roundforest is subject:`,
    list3_item1: `compliance and audit purposes, such as meeting our reporting obligations in our various jurisdictions,
            anti money laundering, tax related obligations, and for crime prevention and prosecution in so far as
            it relates to our staff, users, service providers, facilities etc;`,
    list3_item2: `if necessary, we will use Personal Data to enforce our terms, policies and legal agreements,
            to comply with court orders and warrants and assist law enforcement agencies as required by law,
            to collect debts, to prevent fraud, infringements, identity thefts and any other service misuse,
            and to take any action in any legal dispute and proceeding;`,
    p15_2: `we share Personal Data with our service providers, partners, and authorities where required.`,
    header4: `4. Sharing data with third parties`,
    p16: `We transfer Personal Data to third parties in a variety of circumstances. We endeavor to ensure that
          these third parties use your information only to the extent necessary to perform their functions,
          and to have a contract in place with them to govern their processing on our behalf.
          These third parties include business partners, suppliers, affiliates, agents and/or sub-contractors
          for the performance of any contract we enter into with you. They assist us in providing the Services we offer,
          processing transactions, fulfilling requests for information, receiving and sending communications,
          analyzing data, providing IT and other support services or in other tasks, from time to time.
          These third parties may also include analytics and search engine providers that assist us in
          the improvement and optimization of our websites, and our marketing.`,
    p17: `We periodically add and remove third party providers. At present services provided by third-party providers
          to whom we transfer Personal Data include also the following:`,
    list4_item1: `Website analytics (including Google analytics);`,
    list4_item2: `Partners and eCommerce platforms;`,
    list4_item3: `Document management and sharing services;`,
    list4_item4: `User ticketing and support;`,
    list4_item5: `On-site and cloud-based database services;`,
    list4_item6: `CRM software;`,
    list4_item7: `Data security, data backup, and data access control systems;`,
    list4_item8: `Marketing, user acquisition and retargeting platforms (including Google ads);`,
    list4_item9: `Our lawyers, accountants, and other standard business software and partners.`,
    p18: `In addition, we will disclose your Personal Data to third parties if some or all of our companies
        or assets are acquired by a third party including by way of a merger, share acquisition,
        asset purchase or any similar transaction, in which case Personal Data will be one of the transferred assets.
        Likewise, we transfer Personal Data to third parties if we are under a duty to disclose or share your
        Personal Data in order to comply with any legal or audit or compliance obligation, in the course of any
        legal or regulatory proceeding or investigation, or in order to enforce or apply our terms and other agreements
        with you or with a third party; or to assert or protect the rights, property, or safety of Roundforest,
        our users, or others. This includes exchanging information with other companies and organizations for
        the purposes of fraud protection and credit risk reduction and to prevent cybercrime.`,
    p19: `Selling or Sharing of Personal Information under the CPRA. For purposes of the CPRA, we do not ‘sell’ or
        ‘share’ personal information, nor do we allow any personal information to be used by third parties for their
        own marketing purposes (except where you explicitly requested or provided consent for us to do so). However,
        we use analytics tools and other technologies (as described above), which may be construed as a ‘sale’ under
        CPRA, to which you may opt-out of.`,
    p20: `For avoidance of doubt, we may transfer and disclose non-Personal Data to third parties at our own
        discretion.`,
    header5: `5. Where do we store your data?`,
    p21: `we store your Personal Data across multiple locations globally`,
    p22: `We store your Personal Data on servers owned or controlled by us,
          or processed by third parties on our behalf, by reputable cloud-service providers
          (see the following section regarding international transfers).`,
    header6: `6. International data transfers (EU data subjects)`,
    p23: `we transfer Personal Data within and to the EEA, USA, Israel and elsewhere, with appropriate safeguards
          in place. `,
    p24: `Depending on your location, Personal Data may be transferred to, and stored and processed at, a destination
          outside your location. EU Personal data is transferred outside the European Economic Area (EEA).
          This includes transfer to our headquarters in Israel, a jurisdiction deemed adequate by the EU
          Commission, and to the USA, not currently deemed adequate. Where your Personal Data is transferred outside
          of the EEA, we will take all steps reasonably necessary to ensure that your Data is subject to
          appropriate safeguards, including entering into contracts that require the recipients to adhere to data
          protection standards that are considered satisfactory under EU law and other applicable, and that it is
          treated securely and in accordance with this Privacy Policy. Transfers to Israel are made based on an
          adequacy ruling by the EU Commission. Transfers to the USA are made based on the Standard Contractual
          Clauses published by the EU Commission. For more information about these safeguards, please contact us as
          set forth below.`,
    p25: `We transfer Personal Data to locations outside of the EEA, including in particular USA and Israel,
          in order to:`,
    list5_item1: `store or backup the information;`,
    list5_item2: `enable us to provide you with the Services and products and fulfill our contract with you;`,
    list5_item3: `fulfill any legal, audit, ethical or compliance obligations which require us to make that transfer;`,
    list5_item4: `facilitate the operation of our group businesses, where it is in our legitimate interests and
            we have concluded these are not overridden by your rights;`,
    list5_item5: `to serve our users across multiple jurisdictions; and`,
    list5_item6: `to operate our affiliates in an efficient and optimal manner.`,
    header7: `7. Data retention`,
    p26: `we retain Personal Data according to our data retention policy, as required to meet our obligations,
          protect our rights, and manage our business. `,
    p27: `Roundforest will retain Personal Data it processes only for as long as required in our view, to provide
          the Services and as necessary to comply with our legal and other obligations, to resolve disputes and
          to enforce agreements. We will also retain Personal Data to meet any audit, compliance and business
          best-practices.`,
    p28: `Data that is no longer retained will be anonymized or deleted. Likewise, some metadata and statistical
          information concerning the use of our Services are not subject to the deletion procedures in this policy
          and will be retained by Roundforest. We will not be able to identify you from this data. Some data may
          also be retained on our third-party service providers’ servers until deleted in accordance with their
          privacy policy and their retention policy, and in our backups until overwritten.`,
    header8: `8. Service and websites data collection and cookies`,
    p29: `with your consent, we place cookies on your device. You control our use of cookies through a cookie
          management tool on our websites, or through your device and browser.`,
    p30: `Roundforest uses cookies, pixel tags and other forms of identification and local storage (together referred
          to as “tags/files” hereunder) to distinguish you from other users of the Platform. This helps us to provide
          you with a good user-experience when you browse the Platform and also allows us to improve our Services.`,
    p31: `In many cases, these tags/files lead to the use of your device’s processing or storage capabilities.
          Some of these tags/files are set by Roundforest itself, others by third parties; some only last as long as
          your browser session, while others can stay active on your device for a longer period of time.`,
    p32: `These tags/files can fall into several categories: (i) those that are necessary for functionality or
          Services that you request or for the transmission of communications (functionality tags/files);
          (ii) those that we use to carry out website performance and audience metrics (analytics tags/files) and (iii) the rest (tracking across a network of other websites, advertising, etc.) (other tags/files).<br /><br />
          Internet browsers allow you to change your cookie settings, for example to block certain kinds of
          cookies or files. You can therefore block cookies by activating the setting on your browser that allows
          you to refuse the setting of all or some cookies. However, if you use your browser settings to block
          all cookies, you may not be able to access all or parts of the website, due to the fact that some may
          be functionality cookies. For further information about deleting or blocking cookies,
          please visit: https://www.aboutcookies.org/how-to-delete-cookies/`,
    p33: `Functionality tags/files do not require your consent. For other tags/files, however, we request your
          consent before placing them on your device. You can allow cookies in your browser settings and
          using our website cookie management too.`,
    p34: `To consult the list of cookies which we use on our website, please check your browser's settings.
          Instructions: https://www.wikihow.com/View-Cookies`,
    header9: ` 9. Security and storage of information`,
    p35: `we take data security very seriously, invest in security systems, and train our staff. In the event of
          a breach, we will notify the right people as required by law. `,
    p36: `We take great care in implementing, enforcing and maintaining the security of the Personal Data we process.
          Roundforest implements, enforces and maintains security measures, technologies and policies to
          prevent the unauthorized or accidental access to or destruction, loss, modification, use or disclosure of
          Personal Data. We likewise take steps to monitor compliance of such policies on an ongoing basis.
          Where we deem it necessary in light of the nature of the data in question and the risks to data subjects,
          we encrypt data. Likewise, we take industry standard steps to ensure our websites and Services are safe.`,
    p37: `Note however, that no data security measures are perfect or impenetrable, and we cannot guarantee that
          unauthorized access, leaks, viruses and other data security breaches will never occur. `,
    p38: `Within Roundforest, we endeavor to limit access to Personal Data to those of our personnel who: (i)
          require access in order for Roundforest to fulfill its obligations, including also under its agreements,
          and as described in this Privacy Policy, and (ii) have been appropriately and periodically
          trained with respect to the requirements applicable to the processing, care and handling of the Personal
          Data, and (iii) are under confidentiality obligations as may be required under applicable law. `,
    p39: `Roundforest shall act in accordance with its policies and with applicable law to promptly notify the
          relevant authorities and data subjects in the event that any Personal Data processed by Roundforest is lost,
          stolen, or where there has been any unauthorized access to it, all in accordance with applicable law and on
          the instructions of qualified authority. Roundforest shall promptly take reasonable remedial measures.`,
    header10: `10. Data subject rights`,
    p40: `depending on the law that applies to your Personal Data, you may have various data subject rights, such as
          rights to access, erase, and correct Personal Data, and information rights. We will respect any lawful
          request to exercise those rights. `,
    p41: `Data subjects with respect to whose data GDPR, CPRA or other data protection or privacy laws apply, have
          rights under applicable laws, including, in different circumstances, rights to data portability, rights to
          access data, rectify data, object to processing, and erase data. It is clarified for the removal of doubt,
          that where Personal Data is provided by a user being the data subject's employer, such data subject rights
          will have to be effected through that user, the data subject’s employer. In addition, data subject rights
          cannot be exercised in a manner inconsistent with the rights of Roundforest employees and staff, with
          Roundforest proprietary rights, and third-party rights. As such, job references, reviews, internal notes
          and assessments, documents and notes including proprietary information or forms of intellectual property,
          cannot be accessed or erased or rectified by data subjects. In addition, these rights may not be exercisable
          where they relate to data that is not in a structured form, for example emails, or where other exemptions
          apply. If processing occurs based on consent, data subjects have a right to withdraw their consent. `,
    p42: `A data subject who wishes to modify, delete or retrieve their Personal Data, may do so by contacting us
          (privacy@roundforest.com). Note that we may have to undertake a process to identify a data subject
          exercising their rights. We may keep details of such rights exercised for its own compliance and audit
          requirements. Please note that Personal Data may be either deleted or retained in an aggregated manner
          without being linked to any identifiers or Personal Data, depending on technical commercial capability.
          Such information may continue to be used by us.`,
    p43: `Data subjects in the EU have the right to lodge a complaint, with a data protection supervisory authority
          in the place of their habitual residence. If the supervisory authority fails to deal with a complaint,
          you may have the right to an effective judicial remedy.`,
    header11: `11. General`,
    p44: `Minors. We do not knowingly collect or solicit information or data from or about children under the age of
          16 without parental consent, or knowingly allow children under the age of 16 to register for Roundforest
          Services. If you are under 16, do not register or attempt to register for any of the Roundforest Services
          or send any information about yourself to us. If we learn that we have collected or have been sent Personal
          Data from a child under the age of 16 without appropriate permissions, we will delete that Personal Data as
          soon as reasonably practicable without any liability to Roundforest. If you believe that we might have
          collected or been sent information from a minor under the age of 16, please contact us at:
          privacy@roundforest.com, as soon as possible.`,
    p45: `Changes to this Privacy Policy. The terms of this Privacy Policy will govern the use of the Services and
          websites and any information collected in connection with them. We may amend or update this Privacy Policy
          from time to time. The most current version of this Privacy Policy will be available here.
          Changes to this Privacy Policy are effective as of the stated “Last Revised” date and your continued use
          of our Services will constitute your active acceptance of the changes to and terms of the Privacy Policy.`,
    p46: `Roundforest aims to process only adequate, accurate and relevant data limited to the needs and purposes
          for which it is gathered. It also aims to store data for the time period necessary to fulfill the purpose
          for which the data is gathered. Roundforest only collects data in connection with a specific lawful purpose
          and only processes data in accordance with this Privacy Policy. Our policies and practices are constantly
          evolving and improving, and we invite any suggestions for improvements, questions, complaints or comments
          concerning this Privacy Policy, you are welcome to contact us (details below) and we will make an effort to
          reply within a reasonable timeframe.`,
    p47: `Roundforest’s data protection officer (DPO) may be contacted at`,
    p48: `Last Revised: December 25, 2025`,
  },
  TermsOfService: {
    title: 'Terms of Service',
    subtitle: `IMPORTANT: BY USING THE SERVICES (AS DEFINED BELOW) YOU ACCEPT THE FOLLOWING TERMS AND CONDITIONS.
        IF YOU DO NOT AGREE TO THE TERMS AND CONDITIONS SET FORTH HEREIN, PLEASE DO NOT USE THE SERVICES.`,
    header1: `ACCEPTANCE OF TERMS`,
    p1: `The following instrument consists of the terms and conditions governing your ("you" or "user")
              access to and use of the website of Roundforest Ltd.  ("RoundForest" or "We")
              available at: www.comparaboo.com and the content, features and services
              therein (collectively, the "Services"). These RoundForest Terms of Use together with the
              RoundForest Privacy Policy (collectively, the "Terms") constitute a binding agreement between you and
              RoundForest, and by continuing to use and/or utilize the Services (in whole or in part) in any way or
              manner you agree to abide by, and that you are bound, by these Terms. If you do not understand and/or
              agree to these Terms, you should immediately exit the Services and avoid making any use of the Services.
              We may unilaterally change or add to the terms of these Terms at any time. In the event of a material
              change, We shall notify you via email or by means of a prominent notice on our website.
              You should check our Services periodically and review changes to the Terms at the following
              URL: [Please insert link of these terms and conditions]. By continuing to use the Services
              following such modifications, you agree to be bound by such modifications. If you are not comfortable
              with all of the provisions of these Terms, please do not use the Services.`,
    header2: `LICENSE`,
    p2_strong: `LIMITED LICENSE TO ACCESS THE SERVICES.`,
    p2: ` Subject to the terms and conditions set forth herein,
                RoundForest hereby grants to you, and you accept, a personal, nonexclusive, non-transferable,
                non-assignable, non-sublicensable, revocable, limited license to access and make personal
                non-commercial use of the Services, only according to the terms of these Terms.
                The license shall be granted until terminated in accordance with the terms hereof.`,
    p3_strong: `LIMITATIONS ON USE.`,
    p3: ` You undertake to use the Services solely for your own personal and
                non-commercial use and for no other purpose whatsoever. You hereby declare that you are eighteen
                (18) years old or older. Except as specifically permitted herein, you agree not to (i) sell, license
                (or sub-license), lease, assign, transfer and/or pledge any of your rights under these Terms with/to
                any third party; (ii) transfer, distribute, scrap, copy all or any part of the Services and/or the
                RoundForest IPR (as defined below) and/or use the Services as a service bureau; (iii) refer to the
                Services by use of framing and/or deep-linking; (iv) make use of the Services in any jurisdiction
                where same are illegal or which would subject RoundForest or its affiliates to any registration
                requirement within such jurisdiction or country; (v) use, or encourage, promote, facilitate or
                instruct others to use the Services for any illegal, harmful or offensive use; (vi) transmit or
                upload any viruses, spyware or other harmful, infringing, illegal, disruptive or destructive content,
                messages or files; (vii) access the Services through, or use with the Services any, unauthorized means,
                services or tools, including, without limitation, any data mining, robots, or similar automated means
                or data gathering and extraction tools, including, without limitation, in order to extract for
                re-utilization of any parts of this Services; (viii) distribute, publish, send, or facilitate the
                sending of any advertisements, spam, inappropriate, inaccurate, misleading, fraudulent, libelous,
                defamatory, offensive, threatening, abusive or otherwise illegal content or content which infringes
                Intellectual Property Rights (as defined below) of third parties or their right for privacy; (ix) copy,
                modify, translate, reverse engineer, decompile, disassemble (except to the extent applicable laws
                specifically prohibit such restriction), make any attempt to discover the source code of the Services
                and/or any other software available on the Services or create derivative works thereof; (x) attempt
                to obtain private information from other users in any form or manner whatsoever; (xi) attempt to
                interfere with, hack into or decipher any transmissions to or from the servers for the Service.
                You are solely responsible for obtaining, paying for, repairing and maintaining all the equipment,
                software, hardware and services required for getting access to and using the Services.`,
    header3: `SUBMITTED MATERIALS`,
    p4_strong: `SUBMITTED MATERIALS`,
    p4: ` You shall
          have sole responsibility and liability for Submitted Materials
          (as defined below). Company shall not be liable for any and all parts of the Submitted Materials and
          shall be entitled, under its sole discretion, to remove or edit any of the Submitted Materials at
          Company's sole discretion and without notice or explanation.
          NOTHING IN THESE TERMS OBLIGATES COMPANY TO DISPLAY YOUR SUBMITTED MATERIALS OR TO USE IT AT ALL OR
          IN A CERTAIN MANNER.
          Please note that any and all of your Submitted Materials will be available to the public and may be
          promoted and transferred onward by Company, at its sole discretion, and thus it is advised not to include
          in them any content or information that you wish to keep private. Company does not provide back-up or
          archive services, you are solely responsible for maintaining adequate backups of your Submitted
          Materials.`,
    p5_strong: `LICENSE TO SUBMITTED MATERIALS`,
    p5: `You hereby grant
                Company a worldwide, irrevocable, perpetual,
                royalty-free license to use, host, store, display, reproduce, modify, adapt, edit, publish, and
                distribute your Submitted Materials and fully exploit your Submitted Materials for the provision,
                maintenance and improvement of the Services.`,
    p6_strong: `REPRESENTATIONS AND WARRANTIES`,
    p6: ` You represent and
                warrant to Company that your Submitted Materials:
              (i) comply and will comply with all applicable laws, rules and regulations, the Terms and do not and
              will not infringe the rights of any third party, including any intellectual property rights and the
              right to privacy, (ii) do not and will not contain any threatening, offensive, racist, hateful, violent,
              obscene, libelous, defamatory or otherwise inappropriate or any commercial content, (iii) are and
              shall be free from any restrictions, third party rights, payment obligations and/or royalties
              (including, without limitation, to any collecting societies).`,
    p7_strong: `"Submitted Materials"`,
    p7: ` shall mean any and all material, text, photographs, videos, and information or other data provided and/or
                  uploaded by you to the Services.`,
    header4: `YOUR ACCOUNT`,
    p8: `You are solely responsible for any actions performed in the Services
        under your credentials.
        Keeping your credentials safe is your sole responsibility. If you have any reasons to suspect
        that your credentials were discovered by any third party or that there was an unauthorized access to
        your account you will immediately notify Company and modify your login information.`,
    p9: `We appreciate hearing from our users and welcome your comments regarding the Services.
              Notwithstanding anything to the contrary herein, please be advised, however, that if you send us ideas,
              suggestions, inventions, or materials regarding the Services `,
    p9_strong: `Feedback`,
    p10: `, we shall: (i) own all right,
              title and interest in and to the Feedback without any restriction; (ii) not be subject to any obligation of
              confidentiality; and (iii) be entitled to unrestricted use of the Feedback for any purpose whatsoever,
              without compensation or credit to you or any other person.`,
    header5: `USER INTERACTION`,
    list1_item1: `By the interviews, certain information relating to our business (the “Information”) may be
                disclosed to you
                for the purpose of providing feedback to us during the interview.`,
    list1_item2: `The interviews will be recorded and will be used for our internal purposes only, as further detailed
                in our Privacy Policy which applies to your interview.`,
    list1_item3: `We may use any feedback you provide us about any of our services or products without any limitation,
              free of any payment obligation. You grant us all rights, title and ownership of such feedback.
              You will not acquire any rights or licenses in any of our services or in any of our IP through
              your provision of feedback to us.`,
    header6: `OWNERSHIP OF PROPRIETARY RIGHTS`,
    p11: `All the Intellectual Property Rights (as defined below) evidenced by or embodied
              in and/or contained and/or subsisting therein and/or attached/connected/related to the Services,
              including, without limitation, any underlying software, platforms, algorithms, technology,
              application and website design, any information, services, texts, Submitted Materials, files,
              sound, music, videos, various applications, social graphs, organization, structure, specifications,
              application "look and feel", features and related content that may be created in connection with the
              use of or registration to the Services, including the selection and arrangement of any of the
              foregoing, any modifications, enhancements, improvements and derivatives thereof and all Intellectual
              Property Rights related thereto (collectively, the "RoundForest IPR") are the property of RoundForest
              and/or its respective affiliates which retain all right, title and interest in connection therewith.`,
    p12: `No transfer or grant of any rights is made or is to be implied by any provision of these Terms or
                by any other provision contained in the Services with respect to the RoundForest IPR or otherwise.
                In the event that by operation of law any of the RoundForest IPR is not owned in its entirety by
                RoundForest automatically upon its creation, then you hereby irrevocably assign, transfer, and
                convey to RoundForest the ownership of such RoundForest IPR, including all right, title, and interest
                in connection therewith, free of any charge. You agree to assist RoundForest, at RoundForest's expense,
                to obtain for RoundForest and enforce any Intellectual Property Rights for RoundForest IPR worldwide.
                You will execute any documents that RoundForest may reasonably request for use in obtaining or
                enforcing such RoundForest IPR and other legal protections.`,
    p13_strong: `Intellectual Property Rights`,
    p13: ` means worldwide (a) rights associated with works of
                authorship, designs and photography, including copyrights; (b) trademarks, service marks, domain
                names, logos, trade names, trade dress and goodwill rights whether or not registered; (c) patents,
                patent applications and industrial designs; (d) rights analogous to those set forth herein and any
                other proprietary rights relating to intangible property; (e) divisions, continuations, renewals,
                reissues and extensions of the foregoing (as applicable) now existing or hereafter filed, issued,
                or acquired.`,
    header7: `User Warranties and Representations`,
    p14: `You represent and warrant to RoundForest that: (a) you have, and will have at all times,
            all permits, consents and right, title and interest in connection with the Services and as required
            to fulfill your obligations and grant to RoundForest any and all rights, licenses and consents
            hereunder, including without limitation in respect of the Submitted Material; (b) you and your use
              of the Services will comply with all applicable laws, rules, regulations, statutes, and ordinances.`,
    header8: `PRIVACY`,
    p15: `RoundForest privacy practices are governed by RoundForest\\'s privacy policy,
              the most updated copy of which can be found at `,
    p16: `Privacy Policy`,
    header9: `DISCLAIMER`,
    p17: `YOU AGREE THAT YOUR USE OF THE SERVICES AND/OR THE ROUNDFOREST IPR SHALL BE AT YOUR OWN RISK.
              THE SERVICES, INCLUDING, WITHOUT LIMITATION ROUNDFOREST IPR, ARE PROVIDED "AS IS" AND WITHOUT WARRANTIES
              OF ANY KIND EITHER EXPRESSED OR IMPLIED. TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW,
              ROUNDFOREST DISCLAIMS ALL WARRANTIES, EXPRESSED OR IMPLIED, INCLUDING, BUT NOT LIMITED TO,
              IMPLIED WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, TITLE, AND FITNESS FOR A PARTICULAR PURPOSE.`,
    p18: `ROUNDFOREST DOES NOT WARRANT THAT THE ROUNDFOREST IPR AND/OR SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE,
              OR THAT THESE SERVICES OR THE SERVER(S) THAT MAKES THESE SERVICES AVAILABLE ARE FREE OF VIRUSES OR OTHER
              HARMFUL COMPONENTS.`,
    p19: `ROUNDFOREST DOES NOT WARRANT OR MAKE ANY REPRESENTATIONS REGARDING THE USE OR THE RESULTS OF THE
              USE OF THE ROUNDFOREST IPR OR SERVICES, INCLUDING, WITHOUT LIMITATION, THEIR CORRECTNESS, ACCURACY,
              RELIABILITY, OR OTHERWISE. YOU ARE RESPONSIBLE FOR TAKING ALL PRECAUTIONS YOU BELIEVE ARE NECESSARY
              OR ADVISABLE TO PROTECT YOURSELF AGAINST ANY CLAIM, DAMAGE, LOSS OR HAZARD THAT MAY ARISE BY VIRTUE OF
              YOUR USE OF OR RELIANCE UPON THE SERVICES AND/OR ANY OF THE ROUNDFOREST IPR.`,
    p20: `SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN IMPLIED WARRANTIES. ACCORDINGLY, SOME
              OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.`,
    header10: `LIMITATION OF LIABILITY`,
    p21: `TO THE MAXIMUM PERMITTED UNDER LAW, UNDER NO CIRCUMSTANCES WHATSOEVER WILL ROUNDFOREST AND ITS
              AFFILIATES, PARTNERS, OFFICERS, DIRECTORS, EMPLOYEES, SHAREHOLDERS, AGENTS, LICENSORS, SUBCONTRACTORS
              AND SUPPLIERS BE RESPONSIBLE OR LIABLE TO YOU OR TO ANY OTHER ENTITY, EVEN IF ADVISED OF THE POSSIBILITY
              OF SUCH DAMAGES, UNDER ANY LEGAL THEORY, WHETHER CONTRACT, TORT OR OTHERWISE, FOR ANY DIRECT, COMPENSATORY,
              INDIRECT, INCIDENTAL, CONSEQUENTIAL, INCLUDING, BUT NOT LIMITED TO, ANY LOST PROFITS AND/OR LOST BUSINESS
              OPPORTUNITIES, BUSINESS INTERUPTION, LOSS OF REVENUE, INCOME, GOODWILL, USE, DATA OR OTHER INTANGIBLE
              LOSSES, SPECIAL, EXEMPLARY, OR PUNITIVE DAMAGES THAT RESULT FROM OR RELATE IN ANY MANNER WHATSOEVER TO
              YOUR USE OF THE SERVICES, OR RELIANCE ON ANY OF THE SERVICES AND/OR ROUNDFOREST IPR, OR TO ANY ERRORS,
              INACCURACIES, OMISSIONS, DEFECTS, SECURITY BREACHES, OR ANY OTHER FAILURE TO PERFORM BY ROUNDFOREST.`,
    p22: `SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR
              CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.`,
    p23: `YOU RECOGNIZE AND AGREE THAT THE WARRANTY DISCLAIMERS AND LIABILITY AND REMEDY LIMITATIONS IN
              THESE TERMS ARE MATERIAL BARGAINED FOR BASIS OF THESE TERMS AND THAT THEY HAVE BEEN TAKEN INTO ACCOUNT
              AND REFLECTED IN THE DECISION BY YOU TO ENTER INTO THESE TERMS.`,
    header11: `INDEMNIFICATION`,
    p24: `You agree to defend, indemnify and hold RoundForest and anyone on its behalf,
              including but not limited to, all of its owners, managers, officers, affiliates, employees, agents,
              licensors and suppliers harmless from and against any losses, expenses, liabilities, costs, claims,
              damages (including attorneys' fees, expert fees' and other costs of litigation) arising from, incurred as
              a result of, or in any manner related to: (i) any use of your account and/or your use of the Services;
              (ii) your violation of any third party right, including, without limitation, any copyright, property, or
              privacy right, and including any third party claim in respect of the Submitted Materials; and (iii) any
              breach of these Terms.`,
    header12: `THIRD PARTY CONTENT, PRODUCTS AND SERVICES`,
    p25: `The Services contain content, links and references to third party services, products and resources.
              RoundForest does not control the availability and content of those third party services, products and
              resources. Any concerns regarding any such services, products or resources, or any content or link thereto,
              should be directed to the applicable third party service, product, or resource provider.`,
    p26: `Links are provided only as an informational resource, simply as a service and only for your
              convenience. RoundForest is not responsible or liable for such links and/or content. Should you
              leave the Services via a link contained herein and/or view content that is not provided by RoundForest,
              you do so at your own risk and RoundForest shall not be responsible or liable for damages or losses caused
              in connection therewith. In as much as you are redirected to linked sites, applications and content,
              We recommend you to carefully read and abide by the terms of use and privacy policies of such applications,
              sites and content.`,
    p27: `Some of the content and materials available through the Services may be provided by third parties.
              No reference made in the Services to any third party content (including Submitted Materials
              and advertisements), commercial product, process, or service, or provider of such product, process or service`,
    p28_strong: `Third Party Content`,
    p28: ` constitute or imply an endorsement, recommendation or favoring by RoundForest.`,
    p29: `Any opinions, advice, statements, content, services, products, offers or other information
              expressed or made available by such third parties, are those of the respective author(s) or
              distributor(s) and do not necessarily state or reflect those of RoundForest and RoundForest
              does not endorse, promote, solicit or recommend them or any Third Party Content in any way nor
              shall RoundForest be responsible or liable for any of the foregoing. Any product or service
              ordered in respect of Third Party Content is not ordered from Roundforest, but from the
              applicable third party service or product provider. RoundForest is a mere conduit in respect of
              Third Party Content and is not obligated to screen Third Party Content and makes no warranties or
              representations as to, and shall have no liability for any of the foregoing.hen you click on links
              to various merchants or providers on the Services and make a purchase, this can result in us earning
              a commission. Affiliate programs and affiliations include, but are not limited to, the eBay Partner Network.`,
    header13: `NOTICE AND TAKEDOWN`,
    p30: `In the event that you believe that any content included in the Services
              violates your Intellectual Property Rights, right to privacy or is defamatory or otherwise illegal,
              please file a detailed notice of complaint to RoundForest in the following link [Please insert link at
              which the users may file a detailed notice], identifying such content and detailing the factual basis of
              your complaint and we will make reasonable efforts to remove the content.`,
    header14: `TERMINATION`,
    p31: `We may terminate these Terms and/or suspend your right to access or use any portion or all
              of the Services and/or RoundForest IPR immediately (including, without limitation, the license set
              forth in Section 2.1 above), at our sole discretion and without notice. Upon termination you shall
              immediately cease using the Services and the following Sections shall survive: 1, 2.2, 3-13.`,
    p32: `Without derogating from any other right and remedy provided to RoundForest under law and/or
              these Terms, RoundForest reserves the right to limit or revoke your license and access to and/or
              use of the Services and/or the RoundForest IPR in its sole discretion, at any time, and for any reason,
              including, but not limited to, technical difficulties or violation of these Terms. If your license to
              use the Services expires or is terminated, RoundForest may, without notice, delete or deny you access
              to any of the RoundForest IPR, Submitted Materials or meta data that may remain in its possession or control.`,
    header15: `ARBITRATION, CLASS WAIVER, AND JURY WAIVER`,
    p33_strong: `Applicability of Arbitration Agreement.`,
    p33: `All claims and disputes arising out of or relating to these Terms or the use of the Services that cannot
                  be resolved in small claims court will be resolved by binding arbitration on an individual basis`,
    p34_strong: `Disputes.`,
    p34: `except that you and Company are not required to arbitrate any dispute for
                  enforcement or infringement of either party's Intellectual Property Rights`,
    p35_strong: `Excluded Disputes.`,
    p35: `Any and all Disputes relating to, arising out of, or in any way in connection with your rights of
                    privacy and publicity are not Excluded Disputes.`,
    p36_strong: `Arbitration Rules.`,
    p36: ` The Federal Arbitration
                Act governs the interpretation and enforcement of this dispute-resolution provision. Arbitration
                will be initiated through the American Arbitration Association ("AAA"). If the AAA is not available
                to arbitrate, the parties will select an alternative arbitral forum. The rules of the arbitral forum
                will govern all aspects of this arbitration, except to the extent those rules conflict with these Terms.
                The AAA Consumer Arbitration Rules governing the arbitration are available online at www.adr.org or by
                calling the AAA at 1-800-778-7879. The arbitration will be conducted by a single neutral arbitrator.
                Any Disputes where the total amount sought is less than $10,000 USD may be resolved through binding
                non-appearance-based arbitration, at the option of the party seeking relief. For Disputes where the
                total amount sought is $10,000 USD or more, the right to a hearing will be determined by the arbitral
                forum's rules. Any judgment on the award rendered by the arbitrator may be entered in any court of
                competent jurisdiction.`,
    p37_strong: `Additional Rules for Non-appearance Arbitration`,
    p37: ` If non-appearance arbitration is elected,
                the arbitration will be conducted by telephone, online, written submissions, or any combination of the
                three; the specific manner will be chosen by the party initiating the arbitration. The arbitration
                will not involve any personal appearance by the parties or witnesses unless the parties mutually
                agree otherwise.`,
    p38_strong: `Authority of the Arbitrator`,
    p38: ` The arbitrator will decide the
                  jurisdiction of the arbitrator and the rights and liabilities, if any, of you and Company.
                  The dispute will not be consolidated with any other matters or joined with any other cases or parties.
                  The arbitrator will have the authority to grant motions dispositive of all or part of any claim or
                  dispute. The arbitrator will have the authority to award monetary damages and to grant any non-monetary
                  remedy or relief available to an individual under applicable law, the arbitral forum's rules,
                  and the Terms. The arbitrator will issue a written award and statement of decision describing the
                  essential findings and conclusions on which the award is based, including the calculation of any
                  damages awarded. The arbitrator has the same authority to award relief on an individual basis that a
                  judge in a court of law would have. The award of the arbitrator is final and binding upon you and Company.`,
    p39_strong: `Waiver of Jury Trial`,
    p39: ` YOU AND COMPANY WAIVE ANY CONSTITUTIONAL AND STATUTORY RIGHTS TO GO TO
                COURT AND HAVE A TRIAL IN FRONT OF A JUDGE OR A JURY, OTHER THAN IN RESPECT OF EXCLUDED DISPUTES.
                You and Company are instead electing to have claims and disputes resolved by arbitration.
                In any litigation between you and Company over whether to vacate or enforce an arbitration award,
                YOU AND COMPANY WAIVE ALL RIGHTS TO A JURY TRIAL, and elect instead to have the dispute be resolved by
                a judge.`,
    p40_strong: `Waiver of Class or Consolidated Actions`,
    p40: ` ALL CLAIMS AND DISPUTES WITHIN THE SCOPE OF
                THIS ARBITRATION AGREEMENT MUST BE ARBITRATED OR LITIGATED ON AN INDIVIDUAL BASIS AND NOT ON A CLASS
                BASIS. CLAIMS OF MORE THAN ONE CUSTOMER OR USER CANNOT BE ARBITRATED OR LITIGATED JOINTLY OR CONSOLIDATED
                WITH THOSE OF ANY OTHER CUSTOMER OR USER. If, however, this waiver of class or consolidated actions is
                deemed invalid or unenforceable, neither you nor we are entitled to arbitration; instead all claims
                and disputes will be resolved in a court as set forth in Section 13(12) below.`,
    p41_strong: `Confidentiality`,
    p41: ` No part of the procedures will be open to the public or the media. All evidence
                discovered or submitted at the hearing is confidential and may not be disclosed, except by written
                agreement of the parties, pursuant to court order, or unless required by law. Notwithstanding the
                foregoing, no party will be prevented from submitting to a court of law any information needed to
                enforce this arbitration agreement, to enforce an arbitration award, or to seek injunctive or
                equitable relief.`,
    p42_strong: `Right to Waive`,
    p42: ` Any rights and limitations set forth in this arbitration
                agreement may be waived by the party against whom the claim is asserted. Such waiver will not waive or
                affect any other portion of this arbitration agreement.`,
    p43_strong: `Opt-out`,
    p43: ` You may opt out of this arbitration agreement. If you do so, neither you nor Company
                can force the other to arbitrate. To opt out, you must notify Company in writing no later than thirty
                (30) days after first becoming subject to this arbitration agreement. Your notice must include your name
                and address, your Company username and the email address you used to set up your Company account
                (if you have one), and an unequivocal statement that you want to opt-out of this arbitration agreement.
                You must send your opt-out notice to Company's address published on the Services.`,
    p44_strong: `Small Claims Court`,
    p44: ` Notwithstanding the foregoing, either you or Company may bring an individual
                action in small claims court.`,
    p45_strong: `Arbitration Agreement Survival`,
    p45: ` This arbitration agreement will survive the termination of your
                relationship with Company.`,
    p46_strong: `Venue for Excluded Disputes`,
    p46: ` Excluded Disputes shall be governed by and construed in accordance
                 with the laws of Israel, without regard to the principles of conflict of law therein.
                 The parties consent to the exclusive jurisdiction of the courts of Tel Aviv-Jaffa in respect of
                 Excluded Disputes and hereby submit themselves to the jurisdiction of these courts.`,
    p47_strong: `U.N. Convention`,
    p47: ` The application of the United Nations Convention of Contracts for the
                  International Sale of Goods or other international laws is expressly excluded, whether the claim is
                  in arbitration or at court.`,
    header16: `GENERAL`,
    p48: `(i) These Terms shall be governed by and construed in accordance with the laws of Israel,
               without regard to the principles of conflict of law therein. The parties consent to the
               exclusive jurisdiction of the competent courts of Tel-Aviv with regard to all claims arising out of,
               in connection with, or in any way relating to, these Terms. The application of the United Nations
               Convention of Contracts for the International Sale of Goods or other international laws is expressly
               excluded; (ii) if any provision of these Terms is held to be unenforceable, such provision shall be
               reformed only to the extent necessary to make it enforceable and if such provision is determined to
               be invalid or unenforceable nonetheless, the provision shall be deemed to be severable from the
               remainder of these Terms and shall not cause the invalidity or unenforceability of the remainder
               of these Terms; (iii) You acknowledge and agree that RoundForest has the right, at any time and for
               any reason, to redesign or modify the RoundForest IPR and other elements of the Services or any
               part thereof; (iv) this is the entire agreement between you and RoundForest regarding the subject
               matter herein; (v)  RoundForest may assign these Terms, in whole or in part, in its sole discretion.
               You are not entitled to assign or otherwise transfer the Terms, or any of your rights or
               obligations hereunder, to any third party without the prior written consent of RoundForest.
               Any unauthorized assignment will be void and of no force or effect; (vi) unless otherwise
               expressly provided, no provisions of these Terms are intended or shall be construed to confer
               upon or give to any person or entity other than you and RoundForest any rights, remedies or
               other benefits under or by reason of these Terms; (vii) the failure of either party to enforce
               any rights granted hereunder or to take action against the other party in the event of any breach
               hereunder shall not be deemed a waiver by that party as to subsequent enforcement of rights or
               subsequent actions in the event of future breaches; (viii) all waivers must be in writing.
               Any waiver or failure to enforce any provision of these Terms on one occasion will not be
               deemed a waiver of any other provision or of such provision on any other occasion; (ix) any
               cause of action arising out of or related to the Services must commence within one (1) year
               after the cause of action accrues. Otherwise, such cause of action is permanently barred.
               If you have any further questions or require further clarification, please contact us by
               sending an e-mail to: `,
    p49: `Last updated: September 22, 2022.`,
  },
  Errors: {
    PageNotFound: {
      title: 'Something went wrong',
      description: 'Looks like something went wrong. Were working on it.',
    },
    GeneralError: {
      title: 'Something went wrong',
      description: 'Looks like something went wrong. Were working on it.',
    },
  },
  ProductPage: {
    bestRated: (position: number, categoryName: string) => `#${position} en Mejor Valorados ${categoryName}`,
    ratingOn: (rating: number) => `${rating} Valoración en`,
    amazon: 'Amazon',
    seeMoreOnAmazon: 'Ver más en Amazon',
    readMoreReviews: 'Leer más reseñas',
    sortBy: 'Ordenar por',
    recommended: 'Recomendado',
    price: 'Precio',
    basedOn: 'Basado en datos de popularidad, precios y relevancia actualizados diariamente.',
    availableOn: 'Disponible en',
    discountCard: (discount: number) => `${discount}% de descuento`,
    viewProduct: 'Ver producto',
    seeDealsOn: 'Ver ofertas en:',
    freeShipping: 'Envío gratis',
    shippingMethod: (isFree?: boolean, shippingCost?: string) =>
      `${isFree ? 'Envío gratis' : ''} ${shippingCost ? `+${shippingCost} Envío` : ''}`,
    buyingOptions: 'Opciones de compra',
    aboutThisProduct: 'Sobre este producto',
    quickOverview: 'Resumen rápido de las características destacadas de este producto',
    recommendedProducts: 'Productos recomendados',
    bestIn: (placement: number, category: string) => `#${placement} en ${category} ➔`,
  },
  AiSearchWidget: {
    inputDialogTitle: (variation?: string) => {
      switch (variation) {
        case 'ss-product-v1':
          return 'Smart Search'
        case 'ss-product-v2':
          return 'Smart Search'
        case 'ss-refine-v1':
          return 'Smart Search'
        case 'ss-refine-v2':
          return 'Smart Search'
        case 'nq-product-v1':
          return 'Not Quite Right?'
        case 'nq-product-v2':
          return 'Not Quite Right?'
        case 'nq-refine-v1':
          return 'Not Quite Right?'
        case 'nq-refine-v2':
          return 'Not Quite Right?'
        default:
          return 'Smart Search'
      }
    },
    inputDialogSubtitle: (variation?: string) => {
      switch (variation) {
        case 'ss-product-v1':
          return 'Pin-point precision in every search'
        case 'ss-product-v2':
          return 'Use our AI for pin-point precision in every search'
        case 'ss-refine-v1':
          return 'Refine your search, specify what matters'
        case 'ss-refine-v2':
          return 'Use our AI to refine your search, specify what matters'
        case 'nq-product-v1':
          return 'Specify your ideal item, brand, or price range'
        case 'nq-product-v2':
          return 'Tell our AI your ideal item, brand, or price range'
        case 'nq-refine-v1':
          return 'Refine your search, specify what matters'
        case 'nq-refine-v2':
          return 'Use our AI to refine your search, specify what matters'
        default:
          return 'Pin-point precision in every search'
      }
    },
    placeholder: (variation?: string) => {
      switch (variation) {
        case 'ss-product-v1':
          return 'Find your item: specify brand, type, or model...'
        case 'ss-product-v2':
          return 'Find your item: specify brand, type, or model...'
        case 'ss-refine-v1':
          return 'Refine here: specify product type, features, budget...'
        case 'ss-refine-v2':
          return 'Refine here: specify product type, features, budget...'
        case 'nq-product-v1':
          return 'Enter preferred brand, type, or model...'
        case 'nq-product-v2':
          return 'Enter preferred brand, type, or model...'
        case 'nq-refine-v1':
          return 'Refine here: specify product type, features, budget...'
        case 'nq-refine-v2':
          return 'Refine here: specify product type, features, budget...'
        default:
          return 'Find your item: specify brand, type, or model...'
      }
    },
    resultSubtitle: 'We’ve found the products that best match your needs',
    ctaSubmitText: 'Find it for me',
    scanning: 'Scanning...',
    errorTitle: 'Oops. Small error.',
    errorSubtitle: (isContextError?: boolean) =>
      isContextError ? 'Please provide more context' : 'Why don’t you give it another go.',
    errorCta: 'Try again',
    ctaRedirectText: 'See products',
  },

  PartnershipBanner: {
    title: 'Asociarse con nosotros',
    subtitle: '¿Eres vendedor?',
    subtitleLink: '¡Únete a nosotros y aumenta tus ventas!',
  },
  PrimeDay: {
    metaTitle: (categoryName: string, productsLength: number, locale: string, camelCaseUrl: string) =>
      `${productsLength} Lo mejor en ${categoryName} de ${currentYear} en el ${locale.toUpperCase()} | Prime Deals 48 horas | ${camelCaseUrl}`,
    bannerTitle: 'No te pierdas el Prime Day',
    bannerSubtitle: '¡Hasta 70% de descuento! Ofertas exclusivas, tiempo limitado',
    primeBig: 'Prime Big',
    dealDays: 'Deal Days',
  },
  BlackFriday: {
    metaTitle: (categoryName: string, productsLength: number, locale: string, camelCaseUrl: string) =>
      `${productsLength} Lo mejor en ${categoryName} de ${currentYear} en el ${locale.toUpperCase()} | Los mejores productos del Black Friday | ${camelCaseUrl}`,
    isHere: (blackFridayType: string) => {
      switch (blackFridayType) {
        case 'event':
          return 'Está Aquí!'
        case 'week':
          return 'Semana Está Aquí!'
        default:
          return 'Está Aquí!'
      }
    },
    blackFridayDeal: 'Oferta de Black Friday',
  },
  CyberMonday: {
    metaTitle: (categoryName: string, productsLength: number, locale: string, camelCaseUrl: string) =>
      `${productsLength} Lo mejor en ${categoryName} de ${currentYear} en el ${locale.toUpperCase()} | Los mejores productos del Cyber Monday | ${camelCaseUrl}`,
    isHere: 'Está Aquí!',
    cyberMondayDeal: 'Oferta de Cyber Monday',
  },
  Christmas: {
    christmasDeal: 'Consíguelo Antes de Navidad',
  },
}
export default esES
